export const CreateResolutionProjection = () => {
  return (
    <div className="text-soClean-100">
      <h2>Create Resolution Projection</h2>
    </div>
  );
};
